// **** FINAL PROD DB **** //
import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import "firebase/storage";

const config = {
	apiKey: "AIzaSyDA9WQKsxzbOHkN8phwKh6Y10llMBgz25w",
	authDomain: "piit-52003.firebaseapp.com",
	databaseURL: "https://piit-52003.firebaseio.com",
	projectId: "piit-52003",
	storageBucket: "piit-52003.appspot.com",
	messagingSenderId: "1077844879842",
	appId: "1:1077844879842:web:0c97a5aacf5877ae",
};
firebase.initializeApp(config);

const database = firebase.firestore();
const storage = firebase.storage();
const auth = firebase.auth();

export { firebase, database, storage, auth, config };
